import { createBrowserRouter } from 'react-router-dom'
import Landing from '@/pages/Landing'
import GameSelect from '@/pages/GameSelect'
import Play from '@/pages/Play'
import Challenge from '@/pages/Challenge'
import Profile from '@/pages/Profile'
import Leaderboard from '@/pages/Leaderboard'
import AuthCallback from '@/pages/AuthCallback'

export const router = createBrowserRouter([
  { path: '/', element: <Landing /> },
  { path: '/auth/callback', element: <AuthCallback /> },
  { path: '/games', element: <GameSelect /> },
  { path: '/play/:questId', element: <Play /> },
  { path: '/challenge/:id', element: <Challenge /> },
  { path: '/profile', element: <Profile /> },
  { path: '/leaderboard', element: <Leaderboard /> },
])
